import { InferType, array, number, object, string } from 'yup';

// This is the schema for the response from the start-prices endpoint
// Use yup to validate the response in runtime
export const startPricesSchema = object({
  startPrice: number().nullable(),
  discountedStartPrice: number().nullable(),
  membersDiscountedStartPrice: number().nullable(),
  propertyId: string(),
});

export const startPricesListSchema = array().of(startPricesSchema).required();

export type StartPrices = Partial<InferType<typeof startPricesSchema>>;
export type StartPricesList = InferType<typeof startPricesListSchema>;
